export default "__VITE_ASSET__lD_Mlhdv__ 500w";